import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "setup/redux/RootReducer";

type InitialState = {
  APIUnavailable: boolean;
  AuthAPIUnavailable: boolean;
};

const initialState: InitialState = {
  APIUnavailable: false,
  AuthAPIUnavailable: false,
};

export const apiStatusSlice = createSlice({
  name: "apistatus",
  initialState,
  reducers: {
    setAPIUnavailable: (state, action) => {
      state.APIUnavailable = action.payload;
    },
    setAuthAPIUnavailable: (state, action) => {
      state.AuthAPIUnavailable = action.payload;
    },
  },
});

export const { setAPIUnavailable, setAuthAPIUnavailable } = apiStatusSlice.actions;
export const selectAPIUnavailable = (state: RootState) => state.apiStatus.APIUnavailable;
export const selectAuthAPIUnavailable = (state: RootState) => state.apiStatus.AuthAPIUnavailable;

export default apiStatusSlice.reducer;
